// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20E5r","content":"styles_content__18hNx","row":"styles_row__2EGDK","footer":"styles_footer__3q3EI","phraseLength":"styles_phraseLength__38aEH"};